module.exports = __webpack_public_path__ + "img/wallet.cbadf842.svg";